// extracted by mini-css-extract-plugin
export var aboveInput = "_k6-0";
export var actionButton = "_k6-5";
export var actionButtonContainer = "_k6-1";
export var actionIcon = "_k6-6";
export var aiInfoContainer = "_k6-2";
export var attachmentWrapper = "_k6-7";
export var bold = "_k6-3";
export var checkIcon = "_k6-8";
export var clickingRecipientBar = "_k6-11";
export var commentThreadSwitch = "_k6-a";
export var draftImage = "_k6-b";
export var draftImageContainer = "_k6-c";
export var draftImages = "_k6-e";
export var editButton = "_k6-g";
export var editor = "_k6-f";
export var editorContainer = "_k6-y";
export var editorErrorTooltipWrapper = "_k6-9";
export var headerDivider = "_k6-h";
export var icon = "_k6-i";
export var info = "_k6-j";
export var internal = "_k6-n";
export var internalDivider = "_k6-k";
export var internalMessage = "_k6-l";
export var messageInputCard = "_k6-m";
export var messageInputForm = "_k6-o";
export var messageInputFormInternal = "_k6-p";
export var options = "_k6-q";
export var publicMessageCustomer = "_k6-s";
export var publicMessageMerchant = "_k6-r";
export var removeImageButton = "_k6-d";
export var replyButtons = "_k6-t";
export var showSignatureButton = "_k6-u";
export var spinner = "_k6-v";
export var verticalButtonDivider = "_k6-4";
export var visibilitySelector = "_k6-w";
export var warning = "_k6-x";
export var wrappingText = "_k6-z";
export var writingInternalNoteTopBorder = "_k6-10";